
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Wand, Paintbrush, Plus } from 'lucide-react';
import TemplateCatalog from '@/components/admin/marketing/TemplateCatalog';
import { useToast } from '@/hooks/use-toast';

const BannerTemplatesPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    // Check if we just returned from creating a banner
    if (location.state?.bannerCreated) {
      toast({
        title: "Banner Created",
        description: "Your new banner set has been created successfully!",
      });
      
      // Clear the state so the toast doesn't show again on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state, toast]);

  // Mock logout function for MasterLicenseLayout
  const handleLogout = () => {
    console.log("Logout action would happen here");
  };

  return (
    <MasterLicenseLayout activeTab="banner-templates" onLogout={handleLogout}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start mb-8">
          <div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/master/marketing')}
              className="mb-2"
            >
              <ArrowLeft className="mr-1 h-4 w-4" />
              Back to Marketing
            </Button>
            <h1 className="text-2xl font-bold text-gray-900">Banner Templates</h1>
            <p className="text-gray-600">Select a template to start creating your banner</p>
          </div>
          <div className="mt-4 md:mt-0 space-x-2">
            <Button 
              variant="default"
              onClick={() => navigate('/master/marketing/banner-creation')}
              className="bg-gradient-to-r from-purple-600 to-blue-500 hover:from-purple-700 hover:to-blue-600"
            >
              <Plus className="mr-2 h-4 w-4" />
              Create Banner Set
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/master/marketing/ai-banner')}
            >
              <Wand className="mr-2 h-4 w-4" />
              AI Generator
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/master/marketing/banner-creator')}
            >
              <Paintbrush className="mr-2 h-4 w-4" />
              Manual Creator
            </Button>
          </div>
        </div>

        <TemplateCatalog />
      </div>
    </MasterLicenseLayout>
  );
};

export default BannerTemplatesPage;
